var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      { staticStyle: { "padding-left": "20px" } },
      [
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "success" }, on: { click: _vm.saveHandler } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
            )
          ],
          1
        ),
        _c(
          "el-form",
          {
            staticStyle: { "margin-top": "10px" },
            attrs: { "label-width": "200px", "label-position": "left" }
          },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_LimitReleaseWithoutContract")
                }
              },
              [
                _c("el-switch", {
                  model: {
                    value: _vm.form.enableLimit,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "enableLimit", $$v)
                    },
                    expression: "form.enableLimit"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_TrialOrderDays") } },
              [
                _c("el-input-number", {
                  staticStyle: { width: "200px" },
                  attrs: { min: 0, max: 9999, controls: false },
                  model: {
                    value: _vm.form.trialDays,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "trialDays", $$v)
                    },
                    expression: "form.trialDays"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }